<template>
    <div class="rich-table-container" v-if="rt.headers">
        <div class="label" v-if="label">
            {{label === '_' ? '\u00A0' : label}}
        </div>
        <div class="rich-table-table">
            <table class="rich-table" :class="{'fixed-header': rt.fixedHeader}">
                <thead>
                    <tr v-if="hasSlot('fimenu-header')">
                        <td colspan="100">
                            <div :class="{'sidemenu-contents-header': hasSlot('fimenu-header')}">
                                <div>
                                    <slot name="fimenu-header"></slot>
                                </div>
                            </div>
                        </td>
                    </tr>

                    <tr v-if="(rt.paging || rt.search) && !hidePaging">
                        <td colspan="100">

                            <div class="rich-table-paging-container">

                                <div class="rich-table-header-group">
                                    <div v-if="filtersEnabled" class="rich-table-button-group">
                                        <button v-if="filtersEnabled" title="Reset Filters" class="button-cancel" @click="resetAllFilters">
                                            <i class="fas fa-undo-alt fa-inverse"></i>
                                        </button>
                                    </div>

                                    <div class="rich-table-paging" :style="$grid(isSelectable ? '1-2-4-2-1' : '1.5-2-4-2') " v-if="rt.paging">
                                        <div class="total-rows no-margin-grid" :style="$grid('2-1')">
                                            <span>Results:</span>
                                            <span class="text-bold">{{rt.count}}</span>
                                        </div>
                                        <div class="page-size no-margin-grid" :style="$grid('2-1')">
                                            <span>Page Size:</span>
                                            <span>
                                                <select v-model="rt.pageSize" @change="rt.pageNumber = 1; refresh();">
                                                    <option :value="10">10</option>
                                                    <option :value="25">25</option>
                                                    <option :value="50">50</option>
                                                    <option :value="100">100</option>
                                                </select>
                                            </span>
                                        </div>
                                        <div class="paging-buttons no-margin-grid" :style="$grid('1-1-2-1-1')">
                                            <div class="paging-button"><button :disabled="rt.pageNumber == 1" class="button-clear" @click="goToPage(1)"><i class="fas fa-step-backward"></i></button></div>
                                            <div class="paging-button"><button :disabled="rt.pageNumber == 1" class="button-clear" @click="goToPage(Math.max(rt.pageNumber - 1, 1))"><i class="fas fa-angle-left"></i></button></div>
                                            <div class="paging-button paging-input">
                                                <input v-model="rt.pageNumber" v-on:blur="goToPage(Math.max(Math.min(rt.pageNumber,pageCount),1));" />
                                                <div>/</div>
                                                <input :value="pageCount" readonly />
                                            </div>
                                            <div class="paging-button"><button :disabled="rt.pageNumber == pageCount" class="button-clear" @click="goToPage(Math.min(rt.pageNumber + 1,pageCount))"><i class="fas fa-angle-right"></i></button></div>
                                            <div class="paging-button"><button :disabled="rt.pageNumber == pageCount" class="button-clear" @click="goToPage(pageCount)"><i class="fas fa-step-forward"></i></button></div>
                                        </div>
                                        <div class="total-rows no-margin-grid" v-if="isSelectable" :style="$grid('2-1')">
                                            <span>Selected Items:</span>
                                            <span class="text-bold">{{selectedCheckbox.length}}</span>
                                        </div>
                                        <div class="is-busy" v-show="isBusy">
                                            <span><i class="fas fa-circle-notch fa-spin"></i></span>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="search">
                                    <div v-if="serverSide">
                                        <div class="search-component">
                                            <InputTextbox :showIcon="false" :saturn.sync="rt.searchText" @keyEnter="() => refresh(true)">
                                                <template #action>
                                                    <div class="reset-text" v-if="rt.searchText && rt.searchText != ''" @click="resetTextHandler"><i class="fas fa-times-circle"></i></div>
                                                </template>
                                            </InputTextbox>
                                            <button @click="refresh(true)">Search</button>
                                            <!--<input v-model="rt.searchText" />
                                            <button @click="refresh()">SEARCH</button>-->
                                        </div>
                                    </div>
                                    <div v-else>
                                        <SearchComponent :data="tableData" :output.sync="tableDataFiltered" :searchKeys="searchKeys"></SearchComponent>

                                    </div>
                                </div>
                                <div v-if="hasSlot('top')" class="header-top">
                                    <slot name="top"></slot>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-else-if="filtersEnabled">
                        <td colspan="100">
                            <div class="rich-table-button-group">
                                <button v-if="filtersEnabled" title="Reset Filters" class="button-cancel" @click="resetAllFilters">
                                    <i class="fas fa-undo-alt fa-inverse"></i>
                                </button>
                            </div>
                        </td>
                    </tr>

                    <tr v-if="!hideHeader">
                        <th v-if="isSelectable">
                            <div @click.prevent="onSelectAllItems" v-if="!isRadio && !hideSelectAll">
                                <InputCheckbox v-model="selectAllCheckbox"></InputCheckbox>
                            </div>
                        </th>
                        <th v-for="(h, index) in visibleHeaders" v-bind:key="h.$index" class="rich-table-header" :class="h.cssClass" @click.stop="headerClicked(h)" ref="headers">
                            <div class="rich-header">
                                <div v-if="h.isOpen" class="rich-table-auto-filter-console" :style="positionMenu(index, h.cssClass)">
                                    <div class="auto-filter-section clickable" v-show="h.sortable" @click.stop="sort(h, true);">Sort A <i class="fas fa-long-arrow-alt-right"></i> Z</div>
                                    <div class="auto-filter-section clickable" v-show="h.sortable" @click.stop="sort(h, false);">Sort Z <i class="fas fa-long-arrow-alt-right"></i> A</div>
                                    <div class="auto-filter-section auto-filter-select-all" v-if="h.autoFilter" @click.stop="">
                                        <a href="" @click.prevent.stop="autoFilterToggleSelectAll(h, true)">Select All</a>
                                        <a href="" @click.prevent.stop="autoFilterToggleSelectAll(h, false)">Clear</a>
                                    </div>
                                    <div class="auto-filter-section auto-filter-search-values" v-if="h.autoFilter" @click.stop="">
                                        <div class="search-icon"><i class="fas fa-search"></i></div>
                                        <input v-model="h.autoFilter.searchText" />
                                    </div>
                                    <div class="auto-filter-section auto-filter-values" v-if="h.autoFilter">
                                        <div v-for="v in getAutoFilterValues(h)" :key="v.$index" class="auto-filter-option" @click.stop="toggleAutoFilterValue(h, v)">
                                            <span class="autofilter-checkbox" :class="{'unchecked-checkbox': !v.isSelected}"><i class="fas fa-check"></i></span>
                                            <span class="autofilter-display">{{v.display}}</span>
                                        </div>
                                    </div>
                                    <div class="auto-filter-section auto-filter-close">
                                        <button class="button-block" @click.stop="headerClicked(h)">Close</button>
                                    </div>
                                </div>
                                <div v-if="h.icon" class="icon-header"><i :class="h.icon"></i></div>
                                <div v-else>{{h.display}}</div>
                                <div class="rich-header-options" v-if="h.autoFilter || (h.autoFilter && h.sortable)">
                                    <div class="rich-table-auto-filter">
                                        <div :class="{'active': h.autoFilter.values.some(v => v.isSelected)}"><i class="fas fa-sliders-h"></i></div>
                                    </div>
                                    <div class="rich-header-sort" v-show="h.sortable && !h.autoFilter">
                                        <div :class="{active: rt.sortBy === h.name && !rt.asc}"><i class="fas fa-caret-up"></i></div>
                                        <div :class="{active: rt.sortBy === h.name && rt.asc}"><i class="fas fa-caret-down"></i></div>
                                    </div>
                                </div>
                            </div>
                            <span v-if="h.actions" class="action-cell">
                                <span v-for="ha in h.actions.filter(a => a.header)" :key="ha.name" class="rich-table-actions">
                                    <button @click="ha.action()" :class="ha.cssClass" v-if="ha.type === 'button'">
                                        <span v-if="ha.icon"><i :class="ha.icon.trim().indexOf(' ') != -1 ? ha.icon : 'fas ' + ha.icon"></i></span>
                                        <span v-if="ha.text">{{isFunction(ha.text) ? ha.text() : ha.text}}</span>
                                    </button>
                                    <a href="#" @click.prevent="ha.action()" :class="ha.cssClass" v-if="ha.type === 'link'">
                                        <span v-if="ha.text">{{isFunction(ha.text) ? ha.text() : ha.text}}</span>
                                    </a>
                                </span>
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="noData && rt.data.length <= 0 ">
                        <td :colspan="visibleHeaders.length">{{noData}}</td>
                    </tr>
                    <tr v-for="(d, index) in rt.data" v-bind:key="d.$index">
                        <td v-if="isSelectable">
                            <div v-if="isRadio">
                                <InputRadio ref="radioBox" :valueMatch="d" v-model="selectedCheckbox[0]"></InputRadio>
                            </div>
                            <div @click.prevent="onSelectItem(d)" v-else>
                                <InputCheckbox ref="checkBox" :value="selectedCheckbox.some(sRow => selectionKey(sRow) == selectionKey(d))"></InputCheckbox>
                            </div>
                        </td>
                        <td v-for="h in visibleHeaders" v-bind:key="h.$index" class="rich-table-rows" :class="getCellCssClass(h.cssClass, h.cellCssClass, d)">
                            <div v-if="h.component">
                                <component :is="h.component" v-bind.sync="{data: {nameValue: d._ref[h.name], value: h.value, row: d}}" v-if="h.nonObject"></component>
                                <component :is="h.component" v-bind.sync="{...tableData[index][h.name]}" v-else></component>
                            </div>
                            <div v-else-if="h.slot">
                                <slot :name="h.slot" v-bind="d"></slot>
                            </div>
                            <div v-else>
                                <span v-if="h.actions" class="action-cell">
                                    <span v-for="action in h.actions.filter(a => !a.header && (isFunction(a.type) ? a.type(d) : a.type) != null)" :key="action.name" class="rich-table-actions">
                                        <button @click="action.action(d, index)" :class="action.cssClass" :disabled="isFunction(action.disabled) ? action.disabled(d) : action.disabled" v-if="isFunction(action.type) ? action.type(d) === 'button' : action.type === 'button'">
                                            <span v-if="action.icon"><i :class="action.icon.trim().indexOf(' ') != -1 ? action.icon : 'fas ' + action.icon"></i></span>
                                            <span v-if="action.text">{{isFunction(action.text) ? action.text(d) : action.text}}</span>
                                        </button>
                                        <a href="#" @click.prevent="action.action(d, index)" :class="action.cssClass" v-else-if="isFunction(action.type) ? action.type(d) === 'link' : action.type === 'link'">
                                            <span v-if="action.text">{{isFunction(action.text) ? action.text(d) : action.text}}</span>
                                        </a>
                                        <router-link :to="action.action(d, index)" :class="action.cssClass" v-else-if="isFunction(action.type) ? action.type(d) === 'route' : action.type === 'route'">
                                            <span v-if="action.text">{{isFunction(action.text) ? action.text(d) : action.text}}</span>
                                        </router-link>
                                        <div v-else>
                                            {{isFunction(action.type) ? action.type(d) : action.type}}
                                        </div>
                                    </span>
                                </span>

                                <span v-else>
                                    {{h.filter ? h.filter(h.value(d)) : h.value(d)}}
                                </span>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="anyFooters" class="rich-table-footer">
                        <th v-for="h in visibleHeaders" v-bind:key="h.$index" :class="h.cssClass">
                            {{h.footer ? h.footer() : ''}}
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>

</template>


<script>
    import { defineAsyncComponent } from "vue";
    import { _ } from 'vue-underscore';
    import util from '@/helpers/util';
    import EventBus from '@/services/event-bus'
    import InputRadio from '@/components/InputRadio'
    import InputCheckbox from '@/components/InputCheckbox'
    import InputNumber from '@/components/InputNumber'
    import InputTextbox from '@/components/InputTextbox'
    import SearchComponent from '@/components/SearchComponent'

    export default {
        name: "RichTable",
        props: ['tableData', 'headers', 'fixedHeader', 'serverSide', 'paging', 'additionalHeaders', 'isBusy', 'selectable', 'selectionKey', 'isSelectedKey', 'search', 'hideHeader', 'hidePaging', 'noData', 'label', 'hideSelectAll', 'tableId'],
        data() {
            return {
                rt: {
                    data: null,
                    headers: null,
                    sortBy: '',
                    asc: true,
                    fixedHeader: this.fixedHeader === true ? true : false,
                    paging: null,
                    search: null,
                    pageNumber: null,
                    pageSize: null,
                    count: null,
                    icon: null,
                    nonObject: null,
                    searchText: ''
                },
                filters: [],
                initialData: null,
                selectedCheckbox: [],
                selectAllCheckbox: false,
                initialSorted: null,
                tableDataFiltered: null,
                searchKeys: []
            };
        },
        computed: {
            anyFooters() {
                return _.some(this.rt.headers, (h) => !!h.footer)
            },
            pageCount() {
                if (this.serverSide)
                    return Math.ceil(this.serverSide.total / this.rt.pageSize);
                else
                    return Math.ceil(this.rt.count / this.rt.pageSize);
            },
            util() {
                return util;
            },
            isSelectable() {
                return (this.selectable === 'checkbox' || this.selectable === 'radio');
            },
            isRadio() {
                return this.selectable === 'radio';
            },
            visibleHeaders() {
                return this.rt.headers.filter(h => h.isVisible);
            },
            filtersEnabled() {
                return this.search || this.rt.headers.some(h => h.autoFilter);
            }
        },
        created() {

            if (this.headers && this.headers.length != 0) {
                this.headers.forEach(h => {
                    if (h.searchable) {
                        this.searchKeys.push({ key: h.name, label: h.display, value: typeof h.value == 'function' ? h.value : null })
                    }
                })
            }


            this.tableDataFiltered = this.tableData
            this.setupHeaders();
            this.rt.paging = this.paging ? this.paging : false;
            this.rt.search = this.search ? this.search : false;
            this.rt.pageSize = this.pageSize ? this.pageSize : 10;
            this.rt.pageNumber = this.pageNumber ? this.pageNumber : 1;

            //LOAD IN PREFERENCES FROM LOCAL STORAGE
            let tablePreferences = JSON.parse(localStorage.getItem('RichTablePreferences') ?? '[]');
            let preferenceIndex = tablePreferences?.findIndex(p => p.tableId === this.tableId);

            if (preferenceIndex != -1) {
                let preferenceItem = tablePreferences[preferenceIndex];

                this.rt.headers.forEach(h => {
                    let headerMatch = preferenceItem.headers.find(p => p.name === h.name);
                    if (headerMatch) {
                        h.isVisible = headerMatch.isVisible;
                    }
                });
            }

            //WATCH IF THE DATA CHANGED FROM OUTSIDE
            this.$watch(() => this.$props.tableData, function (newValue) {
                this.tableDataFiltered = this.tableData
                this.init();
            }, { deep: true, immediate: true });

            this.$watch(() => this.tableDataFiltered, function (newValue) {
                this.init();
            }, { deep: true, immediate: true });


            if (this.selectable == 'radio') {
                this.$watch(() => this.selectedCheckbox[0], function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        this.$emit('selectionChanged', newValue);
                    }
                }, { deep: true, immediate: true });
            }

            //TO CLOSE ANY HEADERS WHEN CLICKING OUTSIDE
            EventBus.$on('bodyClicked', this.onBodyClicked);
            this.$once("hook:beforeDestroy", () => {
                EventBus.$off('bodyClicked', this.onBodyClicked);
            });

            if (this.isSelectedKey) {
                this.selectedCheckbox = this.rt.data.filter(r => this.isSelectedKey(r));
            }

            if (!this.hideSelectAll) this.setSelectAllCheckbox();

            if (!util.isNull(this.initialSorted)) {
                this.sort(this.initialSorted, util.isNull(this.initialSorted.asc) ? true : this.initialSorted.asc)
            }

        },
        methods: {
            resetTextHandler() {
                this.rt.searchText = '';
                this.refresh();

            },
            positionMenu(index, cssClass) {
                let position = this.$refs.headers[index].getBoundingClientRect()
                let output = {
                    position: 'fixed',
                    top: (position.top + position.height) + "px",
                }
                //console.log(cssClass)
                if (cssClass && cssClass.includes('left')) {
                    output.left = position.right + "px";
                    output.transform = "translateX(-100%)";
                } else {
                    output.left = position.left + "px"
                }


                return output
            },
            init() {
                if (this.hidePaging) {
                    this.rt.pageSize = this.tableData.length
                }

                //DATA
                if (this.tableDataFiltered && this.tableDataFiltered[0] && typeof this.tableDataFiltered[0] == "object") {
                    this.initialData = this.clone(this.tableDataFiltered);
                    this.initialData = this.tableDataFiltered.map((d, index) => {
                        let x = this.clone(d);
                        x._ref = d;
                        x._index = index;
                        return x;
                    });
                }
                else
                    this.initialData = this.tableDataFiltered && this.tableDataFiltered.length > 0 ? this.tableDataFiltered.map(d => { return { value: d } }) : [];

                this.rt.data = this.clone(this.initialData);
                //console.log(this.rt.data)

                if (this.serverSide) {
                    if (this.serverSide.pageNumber == 1) {
                        this.rt.pageNumber = this.serverSide.pageNumber;
                    }
                    this.rt.pageSize = this.serverSide.pageSize;
                    this.rt.count = this.serverSide.total;
                    this.rt.asc = this.serverSide.asc;
                    this.rt.sortBy = this.serverSide.sortBy;
                }
                else
                    this.rt.count = this.initialData.length




                //SET UP AUTO FILTER VALUES - not for serverside
                if (!this.serverSide && this.rt.headers && this.rt.headers.length > 0) {
                    this.rt.headers.forEach(header => {
                        if (!header.autoFilter) return;

                        if (typeof header.autoFilter === 'object' && header.autoFilter.values) {
                            header.autoFilter.deselectedValues = header.autoFilter.values.map(v => v.value);
                            return;
                        }

                        let allRowValues = [];
                        if (this.initialData && this.initialData.length > 0) {
                            if (typeof this.rowValue(header, this.initialData[0]) !== 'object')
                                allRowValues = this.initialData.map(d => this.rowValue(header, d));
                            else
                                this.initialData.forEach(d => allRowValues.push(...this.rowValue(header, d))); // For array of arrays
                        }

                        let uniqueRowValues = _.uniq(allRowValues);
                        let uniqueRowValuesWithMetaData = uniqueRowValues.map(v => {
                            return {
                                isSelected: false,
                                display: (v !== null ? v.toString() : ''),
                                value: v?.toString() ?? ''
                            };
                        });

                        let sortedValues = _.sortBy(uniqueRowValuesWithMetaData, s => s.display);
                        header.autoFilter.values = sortedValues;
                        header.autoFilter.deselectedValues = sortedValues.map(v => v.display)
                    });
                }
                if (!this.serverSide)
                    this.refresh();
            },
            setSelectAllCheckbox() {
                this.selectAllCheckbox = this.rt.data.every(rtRow => this.selectedCheckbox.some(sRow => this.selectionKey(sRow) == this.selectionKey(rtRow)));
            },
            onSelectAllItems() {
                if (this.selectAllCheckbox) {
                    this.selectedCheckbox = this.selectedCheckbox.filter(selectedRow => !this.rt.data.some(rtRow => this.selectionKey(rtRow) == this.selectionKey(selectedRow)));
                }
                else {
                    let itemsToAdd = this.rt.data.filter(rtRow => this.selectedCheckbox.every(selectedRow => this.selectionKey(selectedRow) != this.selectionKey(rtRow)));
                    this.selectedCheckbox.push(...itemsToAdd);
                }
                this.setSelectAllCheckbox();
                this.$emit("selectionChanged", this.selectedCheckbox);
            },
            onSelectItem(row) {
                //select or unselect
                let existingItemIndex = this.selectedCheckbox.findIndex(i => this.selectionKey(i) == this.selectionKey(row));
                if (existingItemIndex > -1) {
                    this.selectedCheckbox.splice(existingItemIndex, 1);
                }
                else {
                    this.selectedCheckbox.push(row);
                }

                // this is the all items selected on this page checkbox
                if (!this.hideSelectAll) this.setSelectAllCheckbox();

                this.$emit("selectionChanged", this.selectedCheckbox, row, existingItemIndex > -1 ? 'uncheck' : 'check');
            },
            onBodyClicked() {
                this.closeAllHeaders();
            },
            setupHeaders() {
                this.rt.headers = []
                if (this.serverSide) {
                    console.log(111)
                    this.rt.headers = this.serverSide.headers;
                    this.rt.headers.forEach(async h => {
                        h.value = new Function("row", "return row." + (h.rowValue ? h.rowValue : h.name));
                        this.$set(h, 'isOpen', false);
                        this.$set(h, 'anythingChanged', false);
                    });

                    if (this.additionalHeaders) {
                        console.log(222)
                        this.rt.headers = _.sortBy(this.rt.headers.concat(this.additionalHeaders), h => (h.columnOrder ? h.columnOrder : 100));
                    }
                }
                else {
                    console.log('000')
                    if (this.headers) {
                        this.headers.forEach((h) => {

                            if (!util.isNull(h.disabled) ? h.disabled : true) {
                                let header = {
                                    display: h.display,
                                    name: 'name' in h ? h.name : 'value',
                                    sortable: 'sortable' in h ? h.sortable : false,
                                    cssClass: (h.cssClass ?? '') + (h.autoFilter || h.sortable ? ' clickable' : ''),
                                    cellCssClass: h.cellCssClass ?? '',
                                    actions: h.actions,
                                    slot: h.slot,
                                    filter: h.filter,
                                    autoFilterField: h.autoFilterField,
                                    footer: h.footer ? h.footer : null,
                                    autoFilter: typeof h.autoFilter == 'boolean' && h.autoFilter ? {
                                        values: null,
                                        searchText: null,
                                        deselectedValues: []
                                    } : typeof h.autoFilter == 'object' ? {
                                        values: h.autoFilter.values ?? null,
                                        searchText: null,
                                        deselectedValues: h.autoFilter.deselectedValues
                                    } : null,
                                    isOpen: false,
                                    anythingChanged: false,
                                    component: h.component ? h.component : null,
                                    key: h.key ? h.key : null,
                                    icon: h.icon ? h.icon : null,
                                    asc: h.asc,
                                    nonObject: h.nonObject ? h.nonObject : null,
                                };

                                if ('value' in h)
                                    header.value = h.value;
                                else
                                    header.value = function (obj) { return obj[this.name]; };

                                this.rt.headers.push(header);
                                if (h.sorted) {
                                    this.initialSorted = this.rt.headers[this.rt.headers.length - 1]
                                }
                            }
                        });

                    }
                    else {
                        this.rt.headers = Object.keys(this.rt.data[0]).map((h) => {
                            let header = {
                                display: h,
                                name: h,
                                sortable: false,
                                cssClass: '',
                                cellCssClass: '',
                                autoFilter: null,
                                isOpen: false,
                                anythingChanged: false,
                            };

                            header.value = function (obj) { return obj[this.name]; };

                            this.rt.headers.push(header)
                        });
                    }
                }

                this.rt.headers.forEach(h => h.isVisible = true);
            },
            headerClicked(header) {

                this.closeAllHeaders(header);

                if (header.autoFilter) {
                    header.isOpen = !header.isOpen;
                }
                else if (header.sortable) {
                    this.sort(header);
                }

                if (header.isOpen)
                    header.anythingChanged = false;

                //ONCE CLOSED, RUN THE AUTOFILTER & SORT
                if (!header.isOpen && header.anythingChanged) {
                    this.rt.pageNumber = 1;
                    this.refresh();
                }

            }, //opens or closes column header
            autoFilterToggleSelectAll(header, toggle) {
                header.autoFilter.values.forEach(v => {
                    if (v.isSelected != toggle) {
                        this.toggleAutoFilterValue(header, v, toggle);
                    }
                });
            }, //deselect/select all then call refresh
            toggleAutoFilterValue(header, value, override) {

                header.anythingChanged = true;

                value.isSelected = override ? override : !value.isSelected;

                if (!this.serverSide) {

                    if (value.isSelected) {
                        let filterFunc = (typeof this.rowValue(header, this.initialData[0]) !== 'object')
                            ? row => this.rowValue(header, row).toString() === value.value.toString()
                            : row => this.rowValue(header, row).toString().indexOf(value.value) !== -1;

                        header.autoFilter.deselectedValues = header.autoFilter.deselectedValues.filter(v => v !== value.value);

                        this.filters.push({
                            name: header.name + "|" + value.value,
                            func: filterFunc
                        });
                    }
                    else {
                        header.autoFilter.deselectedValues.push(value.value);
                        this.filters = this.filters.filter(f => f.name !== header.name + "|" + value.value);
                    }
                }

            },
            refresh(restartPage = false) {
                if (this.serverSide) {
                    if (restartPage) {
                        this.rt.pageNumber = 1;
                    }
                    this.serverSide.headers = this.rt.headers;
                    this.serverSide.sortBy = this.rt.sortBy;
                    this.serverSide.asc = this.rt.asc;
                    this.serverSide.pageSize = this.rt.pageSize;
                    this.serverSide.pageNumber = this.rt.pageNumber;
                    this.serverSide.searchText = this.rt.searchText;

                    this.serverSide.refresh();
                }
                else {
                    let c = (this.rt.pageNumber - 1) * this.rt.pageSize;
                    let limit = (x, i) => (i <= (this.rt.pageSize - 1));
                    let skip = (x, i) => (i > (c - 1));

                    let filteredData = this.initialData;
                    if (this.filters && this.filters.length > 0) {

                        //group by header name
                        let groups = _.groupBy(this.filters, f => f.name.split('|')[0]);

                        // AND every header and OR every item selected in header
                        filteredData = this.initialData.filter(row => Object.keys(groups).every(key => groups[key].some(f => f.func(row))));
                    }

                    let sortedData = _.sortBy(filteredData, (val) => +val[this.rt.sortBy]);
                    if (!this.rt.asc) sortedData = sortedData.reverse();
                    if (this.paging) sortedData = sortedData.filter(skip).filter(limit);

                    this.rt.count = filteredData.length;
                    this.rt.data = sortedData;


                }
                if (!this.hideSelectAll) this.setSelectAllCheckbox();
            },
            sort(header, direction) {
                //console.log('sorting')

                if (direction === true)
                    this.rt.asc = true;
                else if (direction === false)
                    this.rt.asc = false;
                else if (this.rt.sortBy === header.name)
                    this.rt.asc = !this.rt.asc;
                else
                    this.rt.asc = this.serverSide ? this.serverSide.asc : true;

                this.rt.sortBy = header.name;
                header.isOpen = false;
                this.refresh();


            }, // sorts rt.data
            getAutoFilterValues(header) {
                if (header.autoFilter && header.autoFilter.values)
                    return header.autoFilter.values.filter(v => header.autoFilter.searchText ? v.display.toLowerCase().search(header.autoFilter.searchText.toLowerCase()) > -1 : true);
                else
                    return [];
            },
            goToPage(pageNumber) {
                this.rt.pageNumber = pageNumber;
                this.refresh();
            },

            closeAllHeaders(except) {
                let openHeader = this.rt.headers.find(h => h.isOpen && h != except);
                if (openHeader) this.headerClicked(openHeader);
            },
            rowValue(header, row) {
                return header.filter ? header.filter(header.value(row)) : header.value(row);
            },
            isFunction(functionToCheck) {
                return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
            },
            clone(obj) {
                return JSON.parse(JSON.stringify(obj));
            },
            hasSlot(name) {
                return !!this.$slots[name]
            },
            getCellCssClass(headerCss, cellCssClass, row) {
                if (!headerCss && !cellCssClass) return '';

                let cssClass = (headerCss ?? '') + ' ';

                if (this.isFunction(cellCssClass)) return cssClass + cellCssClass(row);
                return cssClass + (cellCssClass ?? '');
            },
            resetAllFilters() {
                if (this.serverSide) this.resetTextHandler();
                else EventBus.$emit('SearchComponent_Reset');

                this.rt.sortBy = "";
                this.rt.headers.filter(f => f.autoFilter).forEach(h => this.autoFilterToggleSelectAll(h, false));

                this.rt.pageNumber = 1;
                this.refresh();
            },
        },
        components: {
            InputRadio,
            InputNumber,
            InputTextbox,
            InputCheckbox,
            SearchComponent
        }
    };
</script>

<style>
    .total-rows {
        display: flex;
        align-items: center;
    }
</style>